import { bunja } from 'bunja';
import { useBunja } from 'bunja/react';

import Formatted from '@flipster/react/design-utils/formatted';

import { HorizontalButtonGroup } from '../../misc/horizontal-button-group';
import { tpslModalInputBunja } from '../../state';

const percents = [-1, -0.1, +0.1, +1];

export const PriceRateButtons = () => {
  const { buttonPropsArray } = useBunja(priceRateButtonsBunja);
  return (
    <HorizontalButtonGroup>
      {buttonPropsArray.map(({ percent, onClick }) => (
        <HorizontalButtonGroup.Button key={percent} onClick={onClick}>
          <Formatted.Percent value={percent} withPlus />
        </HorizontalButtonGroup.Button>
      ))}
    </HorizontalButtonGroup>
  );
};

const priceRateButtonsBunja = bunja(() => {
  const { addPercent } = bunja.use(tpslModalInputBunja);
  interface PercentAndOnClick {
    percent: number;
    onClick: () => void;
  }
  const buttonPropsArray: PercentAndOnClick[] = percents.map((percent) => ({
    percent,
    onClick: () => addPercent(percent),
  }));
  return { buttonPropsArray };
});
priceRateButtonsBunja.debugLabel = 'priceRateButtonsBunja';
